import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", { class: "text-left" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Policy ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Policy Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Matched App"),
    /*#__PURE__*/_createElementVNode("th", null, "Stream"),
    /*#__PURE__*/_createElementVNode("th", null, "Enabled"),
    /*#__PURE__*/_createElementVNode("th", null, "Add Subscription")
  ])
], -1)
const _hoisted_3 = {
  key: 0,
  class: "text-left"
}
const _hoisted_4 = ["rowspan"]
const _hoisted_5 = ["rowspan"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Date"),
  /*#__PURE__*/_createElementVNode("th", null, "Message")
], -1)

import { reactive, ref, onMounted } from "vue";
import { apiQuery } from "@/api/j24api";
import { mdmServer } from "./types";
import { load } from "webfontloader";
import VSelectSearch from "@/components/VSelectSearch.vue";

interface patchUpdate {
  name: string;
  stream: string;
  selected?: boolean;
}
interface foundPolicies {
  id: number;
  name: string;
  matches: [patchUpdate];
  subExists: boolean;
  policyEnabled: boolean;
}
interface subscription {
  mdmServerId: string;
  policyID: number;
  policyName: string;
  patchName: string;
  patchStream: string;
  createdBy?: string;
  mdmServerName?: string;
  _id?: string;
}
interface LogMessages {
  date: string;
  message: string;
}

interface Logs {
  startAfter: string;
  mdmServerName: string;
  status: string;
  logs: [LogMessages];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardPolicyUpdates',
  setup(__props) {

const mdmServers: mdmServer[] = reactive([]);
const addPolicy = ref(false);
const selectedTab = ref("");
const addSelectedServer = ref("");
const alertTxt: any = ref(false);
const loading = ref(false);
const searchValue = ref("");

const policiesMatched: foundPolicies[] = reactive([]);

// const foundPolicies: { id: number; name: string; matches: [patchUpdate] }[] =
//   reactive([]);

async function getMDMServers() {
  if (mdmServers.length == 0) {
    const result = await apiQuery("J24Auth", "elaadmin/mdmservers", {
      apiAction: "get",
    });
    if (result) {
      result.forEach((record: mdmServer) => {
        mdmServers.push(record);
      });
    }
  }
}

// Current Subscriptions
const currentSubscriptions: subscription[] = reactive([]);
const subscriptionHeaders = [
  { text: "MDM Server", value: "mdmServerName", sortable: true },
  { text: "Policy ID", value: "policyID", sortable: true },
  { text: "Policy Name", value: "policyName", sortable: true },
  { text: "Patch Name", value: "patchName", sortable: true },
  { text: "Patch Stream", value: "patchStream", sortable: true },
  { text: "Actions", value: "actions" },
];

function searchFields() {
  var result: string[] = [];
  subscriptionHeaders.forEach((header) => {
    if (header.text != "Actions") result.push(header.value);
  });
  return result;
}

async function getSubscriptions() {
  loading.value = true;
  const result: subscription[] = await apiQuery(
    "ELA",
    "dashboard/updatepolicies",
    {
      apiAction: "GetPolicySubscriptions",
    }
  );

  if (result) {
    currentSubscriptions.length = 0;
    result.forEach((value) => {
      const name = getServerName(value.mdmServerId);
      currentSubscriptions.push({ ...value, mdmServerName: name });
    });
  }
  loading.value = false;
}

const searchDisabled = ref(false);

async function searchForPolicies() {
  searchDisabled.value = true;
  var mdmURL = "";
  policiesMatched.length = 0;
  mdmServers.forEach((server) => {
    if (server._id == addSelectedServer.value) {
      mdmURL = server.url;
    }
  });

  if (!mdmURL) {
    return;
  }
  const result: foundPolicies[] = await apiQuery(
    "ELA",
    "dashboard/updatepolicies",
    {
      apiAction: "GetUpdatablePolicies",
      mdmServerId: addSelectedServer.value,
      jamfURL: mdmURL,
    }
  );
  if (result) {
    result.forEach((item) => {
      policiesMatched.push({
        ...item,
        subExists: checkSubscriptionExists(item),
      });
    });
  }
  searchDisabled.value = false;
}

function checkSubscriptionExists(policy: foundPolicies) {
  var subExists = false;
  currentSubscriptions.forEach((sub) => {
    if (
      sub.mdmServerId == addSelectedServer.value &&
      sub.policyID == policy.id
    ) {
      subExists = true;
    }
  });
  return subExists;
}

const addButtonDisabled = ref(false);
async function add() {
  addButtonDisabled.value = true;
  const subscriptionsToAdd: subscription[] = [];
  policiesMatched.forEach((policy) => {
    policy.matches.forEach((match) => {
      if (match.selected) {
        subscriptionsToAdd.push({
          mdmServerId: addSelectedServer.value,
          policyID: policy.id,
          policyName: policy.name,
          patchName: match.name,
          patchStream: match.stream,
        });
      }
    });
  });
  try {
    const result = await apiQuery("ELA", "dashboard/updatepolicies", {
      apiAction: "AddPolicySubscription",
      policies: subscriptionsToAdd,
    });
    getSubscriptions();
    selectedTab.value = "subscriptions";
  } catch (error) {
    alertTxt.value = "Error Adding Subscription";
    console.log(error);
  }

  console.log(subscriptionsToAdd);

  addButtonDisabled.value = false;
}

function getServerName(id: string): string {
  var result = "";
  mdmServers.forEach((server) => {
    if (server._id == id) {
      result = server.name;
      return;
    }
  });
  return result;
}

var subscriptionToDelete: subscription;
const displayConfirmDelete = ref(false);
function deleteSubscription(item: subscription) {
  subscriptionToDelete = item;
  displayConfirmDelete.value = true;
}

async function confirmDelete() {
  try {
    const result = await apiQuery("ELA", "dashboard/updatepolicies", {
      apiAction: "DeletePolicySubscription",
      subscriptionID: subscriptionToDelete._id,
    });
  } catch (error) {
    console.log(error);
    alertTxt.value = "Error Removing Subscription";
  }
  displayConfirmDelete.value = false;
  getSubscriptions();
}

const logsHeaders = [
  { text: "Start Date", value: "startAfter" },
  { text: "MDM Server", value: "mdmServerName" },
  { text: "App", value: "task.subscription.patchName" },
  { text: "Package to Deploy ", value: "task.package.packageName" },
  { text: "Status", value: "status" },
];

const logs: Logs[] = reactive([]);

async function getLogs() {
  loading.value = true;
  const result = await apiQuery("ELA", "dashboard/updatepolicies", {
    apiAction: "GetTaskLogs",
  });
  if (result) {
    logs.length = 0;
    result.forEach((log: any) => {
      logs.push(log);
    });
  }
  loading.value = false;
}

const hideSubscribed = ref(true);

onMounted(async () => {
  loading.value = true;
  await getMDMServers();
  await getSubscriptions();
});

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_tabs, {
      modelValue: selectedTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTab).value = $event)),
      color: "#e7541e"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "subscriptions" }, {
          default: _withCtx(() => [
            _createTextVNode("Current Subscriptions")
          ]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "addNew" }, {
          default: _withCtx(() => [
            _createTextVNode("Add Subscription")
          ]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "logs" }, {
          default: _withCtx(() => [
            _createTextVNode("Logs")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: selectedTab.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((selectedTab).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, {
          value: "subscriptions",
          class: "pt-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_col, { class: "text-right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: searchValue.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
                      label: "Search...",
                      variant: "underlined"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_EasyDataTable, {
              headers: subscriptionHeaders,
              items: currentSubscriptions,
              loading: loading.value,
              "theme-color": "#e7541e",
              "search-field": searchFields(),
              "search-value": searchValue.value
            }, {
              "item-actions": _withCtx((item) => [
                _createVNode(_component_v_icon, {
                  onClick: ($event: any) => (deleteSubscription(item))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-delete")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }, 8, ["items", "loading", "search-field", "search-value"]),
            _createVNode(_component_v_dialog, {
              modelValue: displayConfirmDelete.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((displayConfirmDelete).value = $event)),
              persistent: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Confirm Delete Subscription")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (displayConfirmDelete.value = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Cancel ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (confirmDelete()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Delete ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, {
          value: "addNew",
          class: "pt-5 ma-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(VSelectSearch, {
                      items: mdmServers,
                      itemTitle: "name",
                      itemValue: "_id",
                      "no-data-textaasd": "Loading please wait...",
                      label: "Select MDM Server",
                      activateSearch: "",
                      modelValue: addSelectedServer.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addSelectedServer).value = $event))
                    }, null, 8, ["items", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    (addSelectedServer.value)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (searchForPolicies())),
                          disabled: searchDisabled.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Search for Policies")
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_col, {
                  cols: "auto",
                  class: "text-right"
                }, {
                  default: _withCtx(() => [
                    (policiesMatched.length)
                      ? (_openBlock(), _createBlock(_component_v_checkbox, {
                          key: 0,
                          label: "Hide Already Subscribed",
                          modelValue: hideSubscribed.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((hideSubscribed).value = $event))
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (policiesMatched.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_1,
                  _createVNode(_component_v_table, { density: "compact" }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(policiesMatched, (policy) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: policy.id
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(policy.matches, (update, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: update.name
                              }, [
                                (!policy.subExists || !hideSubscribed.value)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                                      (index == 0)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("td", {
                                              rowspan: policy.matches.length
                                            }, _toDisplayString(policy.id), 9, _hoisted_4),
                                            _createElementVNode("td", {
                                              rowspan: policy.matches.length
                                            }, _toDisplayString(policy.name), 9, _hoisted_5)
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("td", null, _toDisplayString(update.name), 1),
                                      _createElementVNode("td", null, _toDisplayString(update.stream), 1),
                                      _createElementVNode("td", null, _toDisplayString(policy.policyEnabled), 1),
                                      _createElementVNode("td", null, [
                                        (!policy.subExists)
                                          ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                              key: 0,
                                              density: "compact",
                                              modelValue: update.selected,
                                              "onUpdate:modelValue": ($event: any) => ((update.selected) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ], 64))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    disabled: addButtonDisabled.value,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (add()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Add")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "logs" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              class: "pa-3 ml-1 mb-3",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (getLogs()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Get Logs")
              ]),
              _: 1
            }),
            _createVNode(_component_EasyDataTable, {
              headers: logsHeaders,
              items: logs,
              loading: loading.value,
              "theme-color": "#e7541e",
              alternating: "",
              "buttons-pagination": "",
              "empty-message": "Click GET LOGS to fetch logs"
            }, {
              "item-startAfter": _withCtx(({ startAfter }) => [
                _createTextVNode(_toDisplayString(startAfter.toLocaleString("en-GB")), 1)
              ]),
              expand: _withCtx((item) => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_table, { class: "text-left" }, {
                          default: _withCtx(() => [
                            _hoisted_6,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.logs, (log) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: log.date,
                                class: "text-left pt-2 pointer"
                              }, [
                                _createElementVNode("td", null, _toDisplayString(log.date), 1),
                                _createElementVNode("td", null, _toDisplayString(log.message), 1)
                              ]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["items", "loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_alert, {
          modelValue: alertTxt.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((alertTxt).value = $event)),
          type: "error",
          icon: "mdi-alert",
          closable: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(alertTxt.value), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})